<template>
  <BigDataContent />
</template>

<script>
import BigDataContent from './templates/bigDataTemplate.vue'
export default {
  components: {
    BigDataContent,
  },
}
</script>

<style lang="scss" scoped></style>
